import utils from '../apiCaller';

export const handleActivation = (body) =>
{
	return utils.store('licenses', body);
};

export const getMyLicenses = (planId='') =>
{
	let path = 'licenses';

	if (planId !== '')
	{
		path += `?planId=${planId}`;
	}

	return utils.fetch(path);
};

export const getMyActiveLicenses = (planId='') =>
{
	let path = 'active/licenses';

	if (planId !== '')
	{
		path += `?planId=${planId}`;
	}

	// eslint-disable-next-line no-console
	// console.log('path ==== ', path);

	return utils.fetch(path);
};

export const getMyActiveLicensesById = (id='') =>
{
	let path = 'active/licenses';

	if (id !== '')
	{
		path += `?id=${id}`;
	}

	// eslint-disable-next-line no-console
	// console.log('path ==== ', path);

	return utils.fetch(path);
};

export const getMyRoomData = (id='') =>
{
	let path = 'active/licenses';

	if (id !== '')
	{
		path += `?id=${id}`;
	}

	// eslint-disable-next-line no-console
	// console.log('path ==== ', path);

	return utils.fetch(path);
};

export const handleUpdateActivation = (body) =>
{
	return utils.update('licenses', body);
};

export const activatieLicenses = (body) =>
{
	return utils.store('activateLicense', body);
};